import React from 'react';

export default function EditIcon() {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_509_5595)">
                <path
                    d="M12.0003 6.91085L9.33368 4.24418M1.66699 14.5775L3.92324 14.3268C4.1989 14.2962 4.33673 14.2809 4.46556 14.2392C4.57985 14.2022 4.68862 14.1499 4.78892 14.0838C4.90196 14.0092 5.00002 13.9112 5.19614 13.715L14.0003 4.91085C14.7367 4.17447 14.7367 2.98056 14.0003 2.24418C13.264 1.5078 12.0701 1.5078 11.3337 2.24418L2.52948 11.0484C2.33336 11.2445 2.2353 11.3425 2.16075 11.4556C2.09461 11.5559 2.04234 11.6647 2.00533 11.779C1.96363 11.9078 1.94831 12.0456 1.91769 12.3213L1.66699 14.5775Z"
                    stroke="#383838"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_509_5595">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.244141)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
